import { RefObject } from 'react';

import styles from './Announce.module.scss';

interface IAnnounceProps {
  text: string;
  ref: RefObject<HTMLDivElement>;
}

export const Announce = ({ text, ref }: IAnnounceProps) => {
  // eslint-disable-next-line react/no-danger
  return <div ref={ref} className={styles.Container} dangerouslySetInnerHTML={{ __html: text }} />;
};
